export default {"src":"/_next/static/media/seatedrow.d90515f8.svg","height":500,"width":500,"blurWidth":0,"blurHeight":0};